let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4yJnq")).then(() => parcelRequire('5Gq9J'));